import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { Country, Port, CountryService, PortService, AirPortService, LclPortService, AlertService } from '../../services';

@Component({
  selector : 'port-multie-selector',
  templateUrl: 'port-multie-selector.html' 
})
export class PortMultieComponent {
  @Input() title: string;
  @Input() countryLabel: string;
  @Input() portLabel: string;
  @Input() portType: string;

  @Output() portListEe:EventEmitter<any> = new EventEmitter();

  @ViewChild("countryList")
  countryListElRef: ElementRef;

  @ViewChild("countryRef")
  countryElRef: ElementRef;

  showCountries:boolean = false;
  showPorts:boolean = false;

  countries: Array<Country> = [];
  filteredCountryList: Array<Country> = [];
  focusedCntryIndex = 0;
  
  portList: Array<any> = [];

  countryPorts: Array<Port> = [];
  selectedCountry: Country;
  selectedPortList: Array<Port> = [];
  filteredCountryPort: Array<any> = [];

  constructor(
    private countryService: CountryService,
    private portService:PortService,
    private airportService:AirPortService,
    private lclPortService:LclPortService,
    private alertService: AlertService

  ) {
    this.countries = this.countryService.countries;
    if(_.isEmpty(this.countries)) {
      this.countryService.countryListEe.subscribe(
        resp => {
          this.countries = resp;
        }
      )
    }
  }

  ngOnInit() {
    this.initPortList();
  }

  initPortList() {
    let emitter:EventEmitter<any>;
    
    if (this.portType === 'air') {
      this.portList = this.airportService.airports;
      emitter = this.airportService.airPortListEe;
    } else if (this.portType === 'lcl') {
      this.portList = this.lclPortService.ports;
      emitter = this.lclPortService.portListEe;
    } else {
      this.portList = this.portService.ports;
      emitter = this.portService.portListEe;
    }
    
    if (!this.portList || !this.portList.length || this.portList.length <=0) {
      emitter.subscribe(
        port => {
          this.portList = port;
        }
      )
    };
  }


  handleShowCountries() {
    this.showCountries = true;
    this.filteredCountryList = this.countries;
  }

  handleSelectCountry(country:Country) {
    this.selectedCountry = country;
    this.showCountries = false;
    this.countryPorts = _.filter(this.portList, {cntryCd : country.cntryCd});
    this.filteredCountryPort = this.countryPorts;
    this.selectedPortList = [];
    this.portListEe.emit(this.selectedPortList);
  }

  setFilteredCountryList(event) {
    if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
      return;
    }

    if(keyword.length > 0) {
      keyword = _.toUpper(keyword.trim()).replace(/\s/g, '');
		  let filteredCountryList = _.map(_.filter(this.countries,
																	(cntry) => {
																		if (keyword.length <= 0) return true;
																		else if (_.toUpper(cntry.cntryNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
																		else if (_.upperCase(cntry.cntryCd).indexOf(keyword) >= 0) return true;
																		else return false;
                                  }));
      
      this.filteredCountryList = _.sortBy(filteredCountryList,
																(cntry) => {
																	let nmIndex = _.toUpper(cntry.cntryNm.trim()).replace(/\s/g, '').indexOf(keyword);
																	let cdIndex = _.upperCase(cntry.cntryCd).indexOf(keyword);
																	if (nmIndex < 0) nmIndex = 999;
																	if (cdIndex < 0) cdIndex = 999;
																	return _.min([nmIndex, cdIndex])
																});
      this.focusedCntryIndex =  0;    
    } 
  }

  onPortAirCityInput(event) {
    if(_.isEmpty(this.selectedCountry)) {
      this.alertService.error('국가를 먼저 선택하세요.');
      return;
    };
    
    let val;

    if(event && event.target) {
      val = event.target.value;
    } else {
      val = event;
    };
    
    let keyword = _.toUpper(val.trim()).replace(/\s/g, '');
      
    let filteredPortList = [];
    if (_.includes(this.portType, 'lcl') || _.includes(this.portType, 'fcl')) {
      filteredPortList = _.map(_.filter(this.countryPorts,
                (port) => {
                  if (keyword.length <= 0) return true;
                  else if (_.toUpper(port.portNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
                  else if (_.upperCase(port.portCd).indexOf(keyword) >= 0) return true;
                  else return false;
                }));

      filteredPortList = _.sortBy(filteredPortList,
            (port) => {
              let nmIndex = _.toUpper(port.portNm.trim()).replace(/\s/g, '').indexOf(keyword);
              let cdIndex = _.upperCase(port.portCd).indexOf(keyword);
              if (nmIndex < 0) nmIndex = 999;
              if (cdIndex < 0) cdIndex = 999;
              return _.min([nmIndex, cdIndex])
            });
    } else {
      filteredPortList = [];
    }

    let filteredAirportList = [];
    if (_.includes(this.portType, 'air')) {
      filteredAirportList = _.map(_.filter(this.countryPorts,
                (airport) => {
                  if (keyword.length <= 0) return true;
                  else if (_.toUpper(airport.portNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
                  else if (_.upperCase(airport.portCd).indexOf(keyword) >= 0) return true;
                  else return false;
                }));

      filteredAirportList = _.sortBy(filteredAirportList,
              (airport) => {
                let nmIndex = _.toUpper(airport.portNm.trim()).replace(/\s/g, '').indexOf(keyword);
                let cdIndex = _.upperCase(airport.portCd).indexOf(keyword);
                if (nmIndex < 0) nmIndex = 999;
                if (cdIndex < 0) cdIndex = 999;
                return _.min([nmIndex, cdIndex])
              });
    } else {
      filteredAirportList = [];
    }
    
    this.filteredCountryPort = _.concat(filteredPortList, filteredAirportList);
    
  }


  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;

		
			suggestListDom = this.countryListElRef.nativeElement;
			focusedIndex = this.focusedCntryIndex;
		
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter   
        if (_.isEmpty(this.filteredCountryList) || !this.focusedCntryIndex == null) return;
        let item = this.filteredCountryList[this.focusedCntryIndex];
        this.handleSelectCountry(item);
			  break;
			case 27: // escape
					this.showCountries = false;
          this.showPorts = false;
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
		}
  
    if (focusedIndex != this.focusedCntryIndex) this.focusedCntryIndex = focusedIndex;
    event.preventDefault();
  }

  checkConfirm(port) {
    if(_.includes(this.selectedPortList, port)) {
      return true;
    } else {
      return false;
    }
  }

  comparePorts() {
    if(this.selectedPortList == this.countryPorts) {
      return true;
    } else {
      return false;
    }
  }

  handleShowPorts() {
    this.showPorts = true;
  }

  selectPort(idx: number, port: Port) {
    let checkbox = document.getElementById('multi-port-cbx-' + idx);
    if (!checkbox) return;
    checkbox['checked'] = !checkbox['checked'];
    this.handlePort(checkbox['checked'], port);
    event.preventDefault();
  }

  handlePortSelect(event, port) {
    let checked: boolean = event.target.checked;
    this.handlePort(checked, port);
    event.stopPropagation();
  }

  handlePort(checked: boolean, port: Port) {
    if(checked) this.selectedPortList.push(port);
    else this.selectedPortList.splice(this.selectedPortList.findIndex(value => value.locationId == port.locationId), 1);
    this.portListEe.emit(this.selectedPortList);
  }

  handleHideCountries() {
    this.showCountries = false;
  }

  handleHidePorts() {
    this.showPorts = false;
  }


  switchValue(target: PortMultieComponent) {
    let targetCntry = target.selectedCountry;
    let targetPorts = target.selectedPortList;

    target.selectedCountry = this.selectedCountry;
    target.selectedPortList = this.selectedPortList;
    this.selectedCountry = targetCntry;
    this.selectedPortList = targetPorts;
  }

  onMouseOverCntry(i) {
    this.focusedCntryIndex = i;
  }

  selectAllPort(event) {
    if(this.comparePorts()) {
      this.selectedPortList = [];
    } else {
      this.selectedPortList = this.countryPorts;
    }

    this.portListEe.emit(this.selectedPortList);
    event.preventDefault();
  }


}


// WEBPACK FOOTER //
// ./src/app/components/selector/port-multie-selector.ts